<template>
  <a-layout id="components-layout-demo-top-side-2" style="height: 100%;">
    <a-layout-header class="header" theme="light" style="background-color: #3ba0e9; padding-left: 20px;">
            <span class="title"><a-icon type="ant-design"/> 溜溜快洗 <a-divider type="vertical"/>
              <!--                <span v-if="userInfo.role === 'vendorAdmin'">
                                  <span>商家版：[{{ userInfo.vendorName }}]</span>
                                  <a-dropdown v-if="userInfo.otherVendorInfos"
                                              style="color: #f0f2f5; margin-left: 2%; font-size: small">
                                      <a @click="e => e.preventDefault()">
                                        切换 <a-icon type="down"/>
                                      </a>
                                      <a-menu slot="overlay">
                                        <a-menu-item v-for="vendorInfo in userInfo.otherVendorInfos">
                                          <a href="javascript:;"
                                             @click="handleChangeVendor(vendorInfo.id)">{{ vendorInfo.vendorName }}</a>
                                        </a-menu-item>
                                      </a-menu>
                                  </a-dropdown>
                                  <coupon-pending-link/>
                              </span>
                              <span v-else>平台版</span>-->后台管理
            </span>

      <span class="user">
                <span v-if="userInfo.name">
                  {{ '欢迎，' + userInfo.name }}
                  <link-button @click="handleLogout"><a-icon type="logout"/> 注 销</link-button>
                </span>
                <span v-else>未登录</span>
            </span>
      <change-password-modal ref="changePasswordModal"></change-password-modal>
    </a-layout-header>
    <a-layout>
      <a-layout-sider width="250">
        <a-menu
            mode="inline"
            :default-selected-keys="[$route.meta.menuKey[1]]"
            :default-open-keys="[$route.meta.menuKey[0]]"
            :style="{ height: '100%', borderRight: 0,}"
        >
          <a-menu-item key="index">
            <router-link :to="{path: '/'}">
              <a-icon type="home"/>
              首页
            </router-link>
          </a-menu-item>
          <template>
            <a-sub-menu key="userManage">
              <a-badge slot="title" :offset="[8,-3]" :count="userTakeExpireCount + unHandleUserCount"><a-icon type="user"/>用户管理</a-badge>
              <a-menu-item key="userList">
                <router-link :to="{path: '/userManage/userList'}">学生管理<a-badge :count="unHandleUserCount" :offset="[-2,-10]" /></router-link>
              </a-menu-item>
              <a-menu-item key="empList">
                <router-link :to="{path: '/userManage/empList'}">员工管理</router-link>
              </a-menu-item>
              <a-menu-item key="rechargeList">
                <router-link :to="{path: '/userManage/rechargeList'}">充值记录</router-link>
              </a-menu-item>
              <a-menu-item key="orderList">
                <router-link :to="{path: '/userManage/orderList'}">洗衣订单<a-badge :count="userTakeExpireCount" :offset="[-2,-10]" /></router-link>
              </a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="vendorManage">
              <span slot="title"><a-icon type="laptop"/>学校管理</span>
              <a-menu-item key="vendorList">
                <router-link :to="{path: '/bizOrgManage/bizOrgList'}">学校列表</router-link>
              </a-menu-item>
              <a-menu-item key="cabinetList">
                <router-link :to="{path: '/bizOrgManage/cabinetList'}">智能柜管理</router-link>
              </a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="customer">
              <a-badge slot="title" :offset="[8,-3]" :count="unReplyCount"><a-icon type="customer-service"/>客服管理</a-badge>
              <a-menu-item key="suggestList">
                  <router-link :to="{path: '/customer/suggestList'}">意见反馈<a-badge :count="unReplyCount" :offset="[-2,-10]" /></router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout style="padding: 0 24px 24px">
        <a-breadcrumb style="margin: 16px 0">
          <a-breadcrumb-item>主页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ $route.meta.title[0] }}</a-breadcrumb-item>
          <a-breadcrumb-item>{{ $route.meta.title[1] }}</a-breadcrumb-item>
        </a-breadcrumb>
        <a-layout-content
            :style="{ background: '#fff', padding: '15px', margin: 0, minHeight: '280px' }"
        >
          <a-card :bordered="false">
            <router-view @refreshNotification="handleNotification"></router-view>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import LinkButton from "../components/LinkButton";
import commonService from "../service/adminCommon";
import ChangePasswordModal from "./ChangePasswordModal";
import CouponPendingLink from "./CouponPendingLink"
import {getUserInfo} from "@/util/userInfoHolder";

export default {
  components: {LinkButton, ChangePasswordModal, CouponPendingLink},
  data() {
    return {
      collapsed: false,
      userInfo: {},
      pollingInterval: null,
      unReplyCount: 0,
      userTakeExpireCount: 0,
      unHandleUserCount: 0
    };
  },
  methods: {
    handleLogout() {
      const hide = this.$message.loading("注销中…")
      setTimeout(() => {
        hide()
        this.$router.push({path: '/login'})
        this.$message.success("注销成功！")
      }, 1000);
    },
    handleNotification() {
      this.fetchData()
    },
    fetchData() {
      commonService.getUnHandleCount().then(res => {
        this.userTakeExpireCount = parseInt(res.data.orderCount)
        this.unReplyCount = parseInt(res.data.customerServiceCount)
        this.unHandleUserCount = parseInt(res.data.userCount)
      })
    },
    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.fetchData();
      }, 5 * 60 * 1000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  },

  created() {
    document.title = "溜溜快洗后台管理"
  },
  mounted() {
    this.userInfo = getUserInfo();
    this.fetchData();
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style>
#components-layout-demo-top-side-2 .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 28px 16px 0;
  float: left;
}

.title {
  font-size: large;
  font-weight: bold;
  color: #f0f2f5;
}

.user {
  font-size: large;
  font-weight: bold;
  color: #f0f2f5;
  float: right;
}
</style>
